import Header from "@/components/Header";
import Seo from "@/components/Seo";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import About from "@/components/About";
import Practice from "@/components/Practice";
import Benefits from "@/components/Benefits";
import Procedure from "@/components/Procedure";
import MarmaPoints from "@/components/MarmaPoints";
import Therapies from "@/components/Therapies";
import FAQ from "@/components/FAQ";
import GoogleReviews from "@/components/GoogleReviews";
import Contact from "@/components/Contact";
import FindUs from "@/components/FindUs";
import Footer from "@/components/Footer";

export default function HomePage() {
    return (
        <div className="bg-cream text-ink" data-testid="home-page">
            <Seo
                title="Agastya Chiro and Ancient Marma Therapy | Marma Chikitsa in Kurnool"
                description="Agastya Chiro and Ancient Marma Therapy — Marma Chikitsa, Ayurvedic wellness and complementary therapies in Nagi Reddy Revenue Colony, near Vastralaya Mall, Kurnool, Andhra Pradesh. Call 89781 33934 to book a consultation."
                path="/"
            />
            <Header />
            <main>
                <Hero />
                <EditorialMarquee />
                <About />
                <Practice />
                <Benefits />
                <Procedure />
                <MarmaPoints />
                <Therapies />
                <FAQ />
                <GoogleReviews />
                <Contact />
                <FindUs />
            </main>
            <Footer />
        </div>
    );
}
